import styles from './form-step-indicator.module.css';
import {FirstIcon, SecondIcon, ThirdIcon} from './icons';

type Props = {
  readonly step: 1 | 2 | 3;
};

export function FormStepIndicator({step}: Props) {
  return (
    <nav aria-label='申請のステップ'>
      <ol className={styles.steps}>
        <li
          className={styles.stepItem}
          aria-current={step === 1 ? 'step' : undefined}
        >
          <FirstIcon isActive={step >= 1} />
          <span>必須項目を入力</span>
        </li>
        <li
          className={styles.stepItem}
          aria-current={step === 2 ? 'step' : undefined}
        >
          <SecondIcon isActive={step >= 2} />
          <span>入力内容を確認</span>
        </li>
        <li
          className={styles.stepItem}
          aria-current={step === 3 ? 'step' : undefined}
        >
          <ThirdIcon isActive={step >= 3} />
          <span>完了</span>
        </li>
      </ol>
    </nav>
  );
}
